import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import NEDDQuoteProposalInfoPageStore, {
  NEDDQuoteProposalInfoPageStoreContext,
  useNEDDQuoteProposalInfoPageStore,
} from 'store/pages/quote/quote-proposal-info/nedd/pageStore';
import NEDDQuoteProposalInfoForm from 'components/quote/quote-proposal-info/NEDD';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { isActionLoading, flowDelegate, canCompleteStep, onComplete, getInitialData } =
    useNEDDQuoteProposalInfoPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={QuoteRouteV2Id.QUOTE_PROPOSAL_INFO}
      isPageLoading={flowDelegate.isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
      pageFooter={{
        onComplete,
        completeButtonText: 'Save',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <NEDDQuoteProposalInfoForm />
    </QuoteFlowLayout>
  );
});

const NEDDQuoteProposalInfoPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () => new NEDDQuoteProposalInfoPageStore({ groupId, periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <NEDDQuoteProposalInfoPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </NEDDQuoteProposalInfoPageStoreContext.Provider>
  );
};

export default NEDDQuoteProposalInfoPage;
